import { render, staticRenderFns } from "./IssueCommentsPc.vue?vue&type=template&id=4e64ceb0&scoped=true&"
import script from "./IssueCommentsPc.vue?vue&type=script&lang=ts&"
export * from "./IssueCommentsPc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64ceb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
